import { PaywallEmailModal as PaywallEmailModalComponent } from './PaywallEmailModal';
import type { Key, ValueOptions } from './src/@types';

export type {
	Key as PaywallEmailModalKey,
	ValueOptions as PaywallEmailModalValueOptions
};

export const PaywallEmailModal = PaywallEmailModalComponent;
